import { render } from "./LotDetails.vue?vue&type=template&id=139d0370"
import script from "./LotDetails.vue?vue&type=script&lang=js"
export * from "./LotDetails.vue?vue&type=script&lang=js"
script.render = render

export default script